import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class RewardGeneratorMode extends Cloneable {
    static DEFAULT = new RewardGeneratorMode(0, "DEFAULT");
    static AMOUNT = new RewardGeneratorMode(1, "AMOUNT");
    static AMOUNT_RANDOM = new RewardGeneratorMode(4, "AMOUNT_RANDOM");
    static ONE_OF = new RewardGeneratorMode(2, "ONE_OF");
    static ONE_OF_AWAITED = new RewardGeneratorMode(5, "ONE_OF_AWAITED");
    static ALL = new RewardGeneratorMode(3, "ALL");

    static _values = [
        this.DEFAULT,
        this.ALL,
        this.AMOUNT,
        this.AMOUNT_RANDOM,
        this.ONE_OF,
        this.ONE_OF_AWAITED
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, RewardGeneratorMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof RewardGeneratorMode) {
            return RewardGeneratorMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof RewardGeneratorMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RewardGeneratorMode());
        } else if (target instanceof RewardGeneratorMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(RewardGeneratorMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});